import React from 'react';
import { useFormContext } from 'react-hook-form';
import { SupplierAvailableDocumentTypes } from 'settings/account/supplier/view/ActionMenu/SupplierAttach/__generated__/SupplierAvailableDocumentTypes';
import { TravelAuthorizationValues } from 'travelAuthorization/TravelPlan/view/interface';
import { TASupplierDetails_supplier } from '../../../../__generated__/TASupplierDetails';
import { AttachFormModal } from './AttachFormModal';
 interface AttachFormProps {
  availableDocumentTypes: SupplierAvailableDocumentTypes | undefined;
  supplier: TASupplierDetails_supplier;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  supplier,
  availableDocumentTypes,
}) => {
  const {
    formState: { isDirty },
  } = useFormContext<TravelAuthorizationValues>();

  return (
    <AttachFormModal
      supplier={supplier}
      availableDocumentTypes={availableDocumentTypes}
      isDirty={isDirty}
    />
  );
};
